export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-10">
          <div className="flex-shrink-0">
            <div className="w-32 h-32 md:w-40 md:h-40 flex items-center justify-center bg-primary-500 rounded-2xl shadow-lg">
              <i className="ri-smartphone-fill text-white text-5xl md:text-6xl"></i>
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-3">
              随时随地 · 掌上观影
            </h2>
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-5">
              68影院移动端已全面适配，手机浏览器打开即可享受高清电影在线观看。支持手势控制、投屏播放，通勤路上、睡前时光，随时随地畅享电影大全。
            </p>
            <div className="flex items-center gap-3 justify-center md:justify-start flex-wrap">
              <span className="inline-flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                iOS 版本
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                安卓版本
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}